import exceptionApiList from "@/service/basic/exceptionApiList";
import service from "@/service/chat_api";
import { api } from "@/service/api";
const myhost = myhostname;
const host = hostname;
const echarthost = echarthostname;
/**
 * @export
 * @param {*} params
 * @returns Prmoise
 * @description 查询账户信息是否绑定
 */
export function getOrderList(params) {
  return new Promise((resolve, reject) => {
    service
      .get(myhost + exceptionApiList.getOrderList, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 获取售后单各种总数
export function loadAsOrderTotalnum(params) {
  return new Promise((resolve, reject) => {
    api
      .get(echarthost + exceptionApiList.queryAsOrderTotalnum, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function getAbnormalDetail(id = "") {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${exceptionApiList.getAbnormalDetail}/${id}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function getAfterOrderDetail(params) {
  return new Promise((resolve, reject) => {
    service
      .get(myhost + exceptionApiList.getAfterOrderDetail, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

export function getChatGroups(params) {
  return new Promise((resolve, reject) => {
    service
      .get(myhost + exceptionApiList.getChatGroups, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 工单管理(创建)
export function getWorkOrder(supplierId = "", params = {}) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${exceptionApiList.getWorkOrder}/${supplierId}`, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 工单管理(受理)
export function getWorkOrderHandle(supplierId = "", params = {}) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${exceptionApiList.getWorkOrderHandle}/${supplierId}`, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 工单详情
export function getWorkOrderDetail(exceptionOrderNo = "") {
  return new Promise((resolve, reject) => {
    service
      .get(
        `${myhost}${exceptionApiList.getWorkOrderDetail}/${exceptionOrderNo}`
      )
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 获取supplierId
// export function getSupplierId() {
//     return new Promise((resolve, reject) => {
//         service.get(`${host}/manage/shop/shop/get?token=7287c78c-60d5-4e0d-8da9-9948050403e4&shop_id=4`).then(res => {
//             resolve(res.data)
//         }).catch(err => {
//             reject(err)
//         })
//     })
// }

// 新建工单
export function buildWorkOrder(params) {
  return new Promise((resolve, reject) => {
    service
      .post(`${myhost}${exceptionApiList.buildWorkOrder}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 根据二级工单类型查询快捷回复
export function exceptionOrderReply(params = {}) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${exceptionApiList.exceptionOrderReply}`, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 新建工单时的问题类型（新）
export function newWorkOrderType(params = {}) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${exceptionApiList.exceptionTypeList}`, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 新建工单时的问题类型
export function workOrderType() {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${exceptionApiList.workOrderType}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 筛选条件展示的二级工单类型
export function secondWorkOrderType() {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${exceptionApiList.secondWorkOrderType}`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 图片上传
export const addImg = `${myhost}${exceptionApiList.addImg}`;

// 视频上传
export const addVideo = `${myhost}${exceptionApiList.addVideo}`;

// 添加备注
export function addRemark(params) {
  return new Promise((resolve, reject) => {
    service
      .post(`${myhost}${exceptionApiList.addRemark}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 修改状态
export function changeStatus(params) {
  return new Promise((resolve, reject) => {
    service
      .put(`${myhost}${exceptionApiList.changeStatus}`, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 根据详情页的关联单号查询其为 售后单 还是 售后大单
export function getAsOrderInfo(aftersalesNo, params = {}) {
  return new Promise((resolve, reject) => {
    service
      .get(`${myhost}${exceptionApiList.getAsOrderInfo}/${aftersalesNo}`, {
        params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 售后单-新建工单-同步售后图片
export function aftersaleImg(businessKey) {
  return new Promise((resolve, reject) => {
    service
      .post(`${myhost}${exceptionApiList.aftersaleImg}/${businessKey}?type=4`)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

// 工单详情-添加补充图片
export const additionalImage = `${myhost}${exceptionApiList.additionalImage}`;

// 工单详情-删除补充图片
export function deleteImage(exceptionOrderNo, imgUrl) {
  return new Promise((resolve, reject) => {
    service
      .delete(
        `${myhost}${exceptionApiList.deleteImage}/additional-commonFile/${exceptionOrderNo}?additionalImage=${imgUrl}`
      )
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/models/exceptionModel.js